// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo___11PiT","menuWrapper":"menuWrapper___1VMWR","sider":"sider___3DNJN","fixSiderBar":"fixSiderBar___2avJv","icon":"icon___bWdA8"};